@if (dados === null) {
  <div class="mt-3">
    <div class="text-center">
      <output class="spinner-border c-primary">
        <span class="visually-hidden">{{mensagemCarregando}}</span>
      </output>
    </div>
    <p class="legenda-spinner">{{mensagemCarregando}}</p>
  </div>
}

@if (dados === false) {
  <div class="text-center mt-3">
    <img [src]="imagemErro" alt="erro na consulta" width="200px">
    <p class="legenda-erro">{{mensagemErro}}</p>
  </div>
}

@if (dados === undefined) {
  <div class="text-center mt-3">
    <img [src]="imagemVazio" alt="sem dados para essa consulta" width="200px">
    <p class="legenda-vazio">{{mensagemVazio}}</p>
  </div>
}
